/** Brand-coloured "New" pill for freshly added categories & articles. */
export function KbNewPill({ className = "", ...props }) {
  return (
    <span
      {...props}
      className={`inline-flex items-center rounded-full px-1.5 py-0.5 text-[9px] font-bold uppercase tracking-wide text-white ${className}`}
      style={{ backgroundColor: "hsl(var(--primary))" }}
      data-testid="kb-new-pill">
      New
    </span>
  );
}
